export const HEADERS = [
	'Time period',
	'Start date',
	'End date',
	'Product',
	'Leads',
	'CPL (Netto)',
	'Total spend (Netto)',
	'WPPK confirmed Shipping',
	'WPPK confirmed Payment',
	'WPPK confirmed SUM',
	'WPPK delivered Shipping',
	'WPPK delivered Payment',
	'WPPK delivered SUM',
];
